module.exports = __webpack_public_path__ + "img/1.e3fe8c5d.png";